export default __webpack_public_path__ + "static/media/Polygone.789a3cb7.svg";